export default __webpack_public_path__ + "static/media/flull.d9c0a5ac.png";